module.exports = __webpack_public_path__ + "01f43047/img/pdf-icon.79f04a36.svg";